import { Heading, Paragraph } from "common/core/typography";

import Styles from "./empty_chart.module.scss";

type EmptyChartProps = {
  heading: string;
  description: string;
};

export function EmptyChart({ heading, description }: EmptyChartProps) {
  return (
    <div className={Styles.empty}>
      <Heading level="h3" textStyle="headingThree">
        {heading}
      </Heading>
      <Paragraph textColor="subtle">{description}</Paragraph>
    </div>
  );
}
